import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { CurrencyInput } from '@eika/currency-input';

import { useTranslation } from '../../translations';

export type BoligverdiLaanebeloepFormData = {
    soektBeloep: number | undefined;
};

interface Props {
    label: string;
}

const BoligverdiLaanebeloep: FC<Props> = ({ label }) => {
    const { validationMessage } = useTranslation();
    const {
        control,
        formState: { errors },
    } = useFormContext<BoligverdiLaanebeloepFormData>();

    return (
        <Controller
            name="soektBeloep"
            control={control}
            rules={{
                required: `${validationMessage.requiredValue}`,
            }}
            render={({ field: { value, onChange } }) => (
                <CurrencyInput
                    name="soektBeloep"
                    label={label}
                    className="max-width-200"
                    placeholder=""
                    type="tel"
                    error={errors.soektBeloep?.message}
                    value={value}
                    onValueChange={(v) => onChange(v.value)}
                />
            )}
        />
    );
};

export default BoligverdiLaanebeloep;
